export type Language = 'en' | 'fr';

export interface Translations {
  language: Language;
  title: string;
  subtitle: string;
  calculate: string;
  contactNow: string;
  scheduleCall: string;
  totalCost: string;
  area: string;
  rate: string;
  cost: string;
  service: string;
  disclaimer: {
    title: string;
    vatNote: string;
    varyNote: string;
    consultNote: string;
    amgLink: string;
  };
  contactForm: {
    title: string;
    description: string;
    name: string;
    email: string;
    phone: string;
    gdprNotice: string;
    submit: string;
  };
}

export const translations: Record<Language, Translations> = {
  en: {
    language: 'en',
    title: 'Renovation Cost Calculator',
    subtitle: "Select Your Services and Enter Dimensions to Instantly Calculate Renovation Costs in the Côte d'Azur!",
    calculate: 'Calculate Renovation Costs',
    contactNow: 'Contact Now',
    scheduleCall: 'Schedule your call',
    totalCost: 'Total Cost (excluding VAT)',
    area: 'Area (m²)',
    rate: 'Rate',
    cost: 'Cost',
    service: 'Service',
    disclaimer: {
      title: 'Important Note:',
      vatNote: 'All prices shown are net amounts, excluding VAT',
      varyNote: 'Final costs may vary based on specific project requirements',
      consultNote: 'Please consult with',
      amgLink: 'AMG Batiment'
    },
    contactForm: {
      title: 'Get Your Renovation Estimate',
      description: 'Please provide your contact details to receive your detailed renovation cost estimation.',
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      gdprNotice: 'By clicking "Show my estimate" you agree to receive promotions and newsletters',
      submit: 'Show My Estimate'
    }
  },
  fr: {
    language: 'fr',
    title: 'Calculateur de Coûts de Rénovation',
    subtitle: "Sélectionnez vos services et entrez les dimensions pour calculer instantanément les coûts de rénovation sur la Côte d'Azur !",
    calculate: 'Calculer les Coûts',
    contactNow: 'Contactez-nous',
    scheduleCall: 'Planifier votre appel',
    totalCost: 'Coût Total (hors TVA)',
    area: 'Surface (m²)',
    rate: 'Tarif',
    cost: 'Coût',
    service: 'Service',
    disclaimer: {
      title: 'Note Importante:',
      vatNote: 'Tous les prix indiqués sont des montants nets, hors TVA',
      varyNote: 'Les coûts finaux peuvent varier selon les exigences spécifiques du projet',
      consultNote: 'Veuillez consulter',
      amgLink: 'AMG Batiment'
    },
    contactForm: {
      title: 'Obtenez Votre Estimation',
      description: 'Veuillez fournir vos coordonnées pour recevoir votre estimation détaillée des coûts de rénovation.',
      name: 'Nom Complet',
      email: 'Adresse Email',
      phone: 'Numéro de Téléphone',
      gdprNotice: 'En cliquant sur "Afficher mon estimation" vous acceptez de recevoir des promotions et newsletters',
      submit: 'Afficher Mon Estimation'
    }
  }
};